function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiveStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5.808 196.703 506.46 100.051",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 693.143 207.626 L 703.168 230.193 L 727.728 232.754 L 709.363 249.261 L 714.518 273.411 L 693.143 261.046 L 671.768 273.411 L 676.923 249.261 L 658.558 232.754 L 683.118 230.193 Z",
    style: {
      fill: "rgb(31, 48, 109)"
    },
    transform: "matrix(-0.809017, 0.587785, -0.587785, -0.809017, 949.559912, 33.892923)",
    bxShape: "star 693.143 243.991 36.365 36.365 0.469 5 1@5879ff5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 693.143 207.626 L 703.168 230.193 L 727.728 232.754 L 709.363 249.261 L 714.518 273.411 L 693.143 261.046 L 671.768 273.411 L 676.923 249.261 L 658.558 232.754 L 683.118 230.193 Z",
    style: {
      fill: "rgb(31, 48, 109)"
    },
    transform: "matrix(-0.809017, 0.587785, -0.587785, -0.809017, 1152.246191, 33.892953)",
    bxShape: "star 693.143 243.991 36.365 36.365 0.469 5 1@5879ff5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 693.143 207.626 L 703.168 230.193 L 727.728 232.754 L 709.363 249.261 L 714.518 273.411 L 693.143 261.046 L 671.768 273.411 L 676.923 249.261 L 658.558 232.754 L 683.118 230.193 Z",
    style: {
      fill: "rgb(31, 48, 109)"
    },
    transform: "matrix(-0.809017, 0.587785, -0.587785, -0.809017, 746.873388, 33.892984)",
    bxShape: "star 693.143 243.991 36.365 36.365 0.469 5 1@5879ff5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 693.143 207.626 L 703.168 230.193 L 727.728 232.754 L 709.363 249.261 L 714.518 273.411 L 693.143 261.046 L 671.768 273.411 L 676.923 249.261 L 658.558 232.754 L 683.118 230.193 Z",
    style: {
      fill: "rgb(31, 48, 109)"
    },
    transform: "matrix(-0.809017, 0.587785, -0.587785, -0.809017, 848.216711, 33.892923)",
    bxShape: "star 693.143 243.991 36.365 36.365 0.469 5 1@5879ff5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 693.143 207.626 L 703.168 230.193 L 727.728 232.754 L 709.363 249.261 L 714.518 273.411 L 693.143 261.046 L 671.768 273.411 L 676.923 249.261 L 658.558 232.754 L 683.118 230.193 Z",
    style: {
      fill: "rgb(31, 48, 109)"
    },
    transform: "matrix(-0.809017, 0.587785, -0.587785, -0.809017, 1050.903174, 33.892923)",
    bxShape: "star 693.143 243.991 36.365 36.365 0.469 5 1@5879ff5a"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveStars);
export default __webpack_public_path__ + "static/media/FiveStars.b1206262d652ef319f71ffa6086976a4.svg";
export { ForwardRef as ReactComponent };